export const REQUEST_QUESTION = 'REQUEST_QUESTION';
export const RECEIVE_QUESTION = 'RECEIVE_QUESTION';
export const RECEIVE_QUESTION_FAIL = 'RECEIVE_QUESTION_FAIL';
